import { store } from "store/store";

export const storeState = () => async (dispatch) => {
    const state = await store.getState().products;
    dispatch({
        type: 'STATE',
        payload: state
    })
}